import Vue from 'vue'
import Vuex from 'vuex'
import {db} from "@/firebase/db"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      name: "guest",
      authenticated: false,
    },
  },
  getters: {
    user: state => state.user
  },
  mutations: {
    setUser (state, payload) {
      state.user = {...state.user, ...payload}
    },
  },
  actions: {
    async setUser ({ commit, state }, payload) {
      if (state.user.authenticated) {
        console.log("Update user profile: ", payload, state.user.name)
        const name = payload.name
        const uid = state.user.uid
        const userRef = db.collection('users').doc(uid)
        const oldUnameRef = db.collection('usernames').doc(state.user.name)
        const newUnameRef = db.collection('usernames').doc(name)

        await db.runTransaction(async tx => {
          const newUnameDoc = await tx.get(newUnameRef)

          if (newUnameDoc.exists) {
            if (newUnameDoc.data().user != uid) {
              throw new Error('このユーザー名は使用できません')
            }
            // No need to update
          } else {
            // Remove old username doc
            tx.delete(oldUnameRef)
            // Create new username doc
            tx.set(newUnameRef, { user: uid })
            // Update name
            tx.update(userRef, { name: name })
          }
        })
        
        // Update store
        commit('setUser', payload)
      }
    }
  }
})
